import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { pending } from 'redux-saga-thunk';
import { Popconfirm, notification, Icon } from 'antd';
import uniq from 'lodash/uniq';
import get from 'lodash/get';
import LineItemAppList from '../../../components/atoms/LineItemAppList/index';
import { resourceDeleteRequest, resourceListReadRequest } from '../../../store/resource/actions';
import { fromEntities, fromResource } from '../../../store/selectors';
import PopoverManual from '../../../components/atoms/PopoverManual/index';
import { alcoholOptions } from '../../../components/molecules/AlcoholTab/index';

class LineItemAppListContainer extends Component {
  state = {
    filterDropdownVisible: false,
  };

  componentDidMount() {
    this.refresh(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const itemId = nextProps.match.params.lineItemId ? 'lineItemId' : 'revisionId';

    if (get(nextProps, ['params', itemId]) !== get(this.props, ['params', itemId])) {
      this.refresh(nextProps);
    }
  }

  refresh = ({ getAppList }) => {
    getAppList().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve list of applications.',
        duration: 0,
      })
    );
  };

  columns = () => [
    {
      title: 'Target Apps',
      dataIndex: 'display_name',
      render: (text, record) => [
        `${record.app_id} - ${record.display_name} - ${record.package} - ${record.pub_name}`,
        <Icon
          key={`${record.app_id}-${record.os_type}`}
          style={{
            marginLeft: 5,
            color: record.os_type === 'a' ? '#A4C639' : '#999999',
            fontSize: 26,
          }}
          type={record.os_type === 'a' ? 'android' : 'apple'}
        />,
      ],
    },
    {
      title: 'Status',
      dataIndex: 'action',
    },
    {
      title: 'Remove All',
      dataIndex: '',
      key: '',
      render: (text, record) => (
        <Popconfirm
          placement="topRight"
          title={`Are you sure you want to remove this ${record.type}?`}
          onConfirm={() => {
            if (record.type === 'app') {
              return this.props
                .deleteApp(record.app_id)
                .then(() =>
                  notification.success({
                    message: 'Success',
                    description: 'App removed.',
                    duration: 4,
                  })
                )
                .catch(e =>
                  notification.error({
                    message: 'Error',
                    description: typeof e === 'string' ? e : 'Could not remove app.',
                    duration: 0,
                  })
                );
            }
          }}
          okText="Yes"
          cancelText="No"
        >
          <a href="#remove">Remove</a>
        </Popconfirm>
      ),
      filterDropdownVisible: this.state.filterDropdownVisible,
      onFilterDropdownVisibleChange: visible => this.setState({ filterDropdownVisible: visible }),
      filterDropdown: (
        <PopoverManual
          title="Are you sure you want to remove all?"
          loading={this.props.loadingDeleteAll}
          onConfirm={() => {
            this.props
              .deleteAll()
              .then(() => {
                this.setState({ filterDropdownVisible: false });
                notification.success({
                  message: 'Success',
                  description: 'All apps have been removed.',
                  duration: 4,
                });
              })
              .catch(e =>
                notification.error({
                  message: 'Error',
                  description: typeof e === 'string' ? e : 'Could not remove all apps.',
                  duration: 0,
                })
              );
          }}
          onCancel={() => this.setState({ filterDropdownVisible: false })}
        />
      ),
      filterIcon: <Icon type="delete" style={{ color: '#108ee9' }} />,
    },
  ];

  render() {
    return <LineItemAppList columns={this.columns()} {...this.props} />;
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { forecastId, lineItemId, revisionId },
    },
  }
) => {
  const resource = lineItemId ? 'advertiserAd' : 'forecastRevision';

  const list = fromEntities
    .getList(state, `${resource}App`, uniq(fromResource.getList(state, `${resource}App`)))
    .map(c => ({ ...c, type: 'app' }));

  const alcoholTypes = get(
    fromEntities.getDetail(
      state,
      'advertiserAdAlcohol',
      fromResource.getDetail(state, 'advertiserAdAlcohol')
    ),
    'alcohol',
    []
  ).map(a => alcoholOptions.find(b => b.value === a).label);

  return {
    loadingDeleteAll: pending(state, `${resource}AppDelete`),
    alcoholTypes,
    list,
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { forecastId, lineItemId, revisionId },
    },
  }
) => {
  const itemId = lineItemId || revisionId;
  const resource = lineItemId ? 'advertiser-ad/:itemId' : 'forecast/:forecastId/revision/:itemId';
  const resourceGet = lineItemId ? 'advertiser-ad/:id' : 'forecast/:forecastId/revision/:id';

  return {
    deleteAll: () => dispatch(resourceDeleteRequest(`${resource}/app`, { itemId, forecastId })),
    deleteApp: appId =>
      dispatch(resourceDeleteRequest(`${resource}/app/:id`, { itemId, forecastId, id: appId })),
    getAppList: () =>
      dispatch(resourceListReadRequest(`${resourceGet}/app`, {}, { id: itemId, forecastId })),
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LineItemAppListContainer);
